import React, { Component } from 'react';
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl'; // https://docs.mapbox.com/mapbox-gl-js/guides/install/#excluding-mapbox-gl-js-explicitly-from-transpilation
import 'mapbox-gl/dist/mapbox-gl.css';
import moment from 'moment';
import MapboxToggleSatelliteControl from 'APP_ROOT/components/mapbox/mapboxExtendedControls/mapboxToggleSatelliteControl';
import MapboxToggleGeofenceControl from 'APP_ROOT/components/mapbox/mapboxExtendedControls/mapboxToggleGeofenceControl';
import MapboxToggleFullscreenControl from 'APP_ROOT/components/mapbox/mapboxExtendedControls/mapboxToggleFullscreenControl';
import imageLiveStream from 'APP_ROOT/components/pages/dashboard/EventMedia/images/live-stream-w64.svg';
import MapboxHelper from 'APP_ROOT/components/mapbox/mapboxHelper';
import MapboxHelper2 from 'APP_ROOT/components/mapbox/mapboxHelperDashboard';
import HistoryPopup from 'APP_ROOT/components/mapbox/mapboxRoutePopup';
import ResizeThrottler from 'APP_ROOT/components/ResizeThrottler';
import ColorUtil from 'APP_ROOT/components/common/ColorUtil';
import { strings } from 'APP_ROOT/localization';
import fscreen from 'fscreen';
import Events from '../../../components/common/events';
import { RAVEN_EVENTS_AI, RAVEN_EVENTS_PROBLEM, RAVENS_EVENTS_ENGINE, RAVENS_EVENTS_GEOFENCE, RAVENS_EVENTS_SPEEDING } from '../../../components/common/EventsUtils';

const ROUTE_SOURCE_ID = 'route';
const ROUTE_LAYER_ID = 'route';
const ROUTE_LINE_COLOR = 'rgba(42, 174, 211, 1.0)';
const ROUTE_LINE_WIDTH = 6;

const EVENTS_SOURCE_ID = 'events';
const EVENTS_LAYER_ID = 'events';

const GEOFENCE_SOURCE_ID = 'geofences';
const GEOFENCE_LABEL_SOURCE_ID = 'geofence_labels';
const GEOFENCE_LAYER_ID = 'geofences';
const GEOFENCE_LABEL_LAYER_ID = 'geofence_labels';

const SELECTED_EVENTS_SOURCE_ID = 'selected_events';
const SELECTED_EVENTS_LAYER_ID = 'selected_events';

const ENDPOINTS_SOURCE_ID = 'trip-endpoints';
const ENDPOINTS_LAYER_ID = 'trip-endpoints';

const SOURCE_ENHANCED_VIDEO_ACCESS_ROUTE_NAME = "klashwerks_enhanced_video_access_route_highlight_line";
const LAYER_ENHANCED_VIDEO_ACCESS_ROUTE_NAME = "klashwerks_enhanced_video_access_route_highlight_layer";
const SOURCE_ENHANCED_VIDEO_ACCESS_POINT_NAME = "klashwerks_enhanced_video_access_point_highlight_point";
const LAYER_ENHANCED_VIDEO_ACCESS_POINT_NAME = "klashwerks_enhanced_video_access_point_highlight_layer";

const MAPBOX_SATELLITE_STYLE_ID = "cjve3u9xg6wey1gmpnmnip36t";
const MAPBOX_DEFAULT_DARK_STYLE_ID = "cjs6ev22e0j5u1fnu2z4eg3mu";
const MAPBOX_DEFAULT_LIGHT_STYLE_ID = "cjrtvghfhkgwa2so1ig6w6h0a";

const ENHANCED_VIDEO_ACCESS_ROUTE_HIGHLIGHT_THROTTLE_DELAY = 41.6666667; // Adjust for performance optimization.  E.g.s 41.6666667 (24/s), 83.3333333 (12/s), 166.66667 (6/s), 333.333333 (3/s)

const EventIcons = {
    TRIP_START: 'start-marker',
    TRIP_END: 'end-marker',
    PARKED: 'parked-marker',
    DEFAULT: 'map-feature'
};

const EventColors = {
    SPEEDING: 'rgba(192, 0, 0, 1.0)',
    SPEEDING_SELECTED: 'rgba(243, 47, 47, 1.0)',
    ENGINE_STATE_CHANGE: 'rgba(41, 126, 0, 1.0)',
    ENGINE_STATE_CHANGE_SELECTED: 'rgba(92, 177, 27, 1.0)',
    PROBLEM: 'rgba(192, 0, 0, 1.0)',
    PROBLEM_SELECTED: 'rgba(243, 47, 47, 1.0)',
    GEOFENCE: 'rgba(137, 137, 137, 0.8)',
    GEOFENCE_SELECTED: 'rgba(137, 137, 137, 1.0)',
    AI: 'rgba(66, 100, 251, 0.8)',
    AI_SELECTED: 'rgba(66, 100, 251, 1.0)',
    DEFAULT: 'rgba(154, 112, 0, 1.0)',
    DEFAULT_SELECTED: 'rgba(205, 163, 51, 1.0)'
};

// normalize a degree value into [-180..180] range
function wrap(deg) {
    while (deg < -180) deg += 360;
    while (deg > 180) deg -= 360;
    return deg;
}


export default class CardMap extends Component {

    constructor(props) {

        super(props);

        this.popupKillTimeout = null;

        this.mapLoaded = false;

        this.mapboxControlShouldDisplaySatelliteByDefault = false;
        this.mapboxToggleSatelliteControl = null;
        this.mapboxControlShouldFullscreen = false;
        this.mapboxToggleFullscreenControl = null;
        this.routeDelayedZoom = true;
        this.endPointsDelayedZoom = false;

        this.sourceEnhancedVideoAccessRoute = undefined; // quick reference for rendered SOURCE_ENHANCED_VIDEO_ACCESS_ROUTE_NAME
        this.sourceEnhancedVideoAccessPoint = undefined; // quick reference for rendered SOURCE_ENHANCED_VIDEO_ACCESS_POINT_NAME
        this.sourceEnhancedVideoAccessRouteUpdateTimerId = undefined; // used by throttle function

        this.sourceEnhancedVideoAccessRouteFeatureCollection = undefined; // boiled down version from Dashboard (see mapDataModel usage of routeFeatureCollection for SOURCE_ENHANCED_VIDEO_ACCESS_ROUTE_NAME).  Only used by the enhanced video access feature on this map
        this.sourceEnhancedVideoAccessPointFeatureCollection = undefined; // boiled down version from Dashboard (see mapDataModel usage of routeFeatureCollection for SOURCE_ENHANCED_VIDEO_ACCESS_POINT_NAME).  Only used by the enhanced video access feature on this map
        document.addEventListener(Events.ENHANCED_VIDEO_ACCESS_ROUTE_HIGHLIGHT_REQUEST, this.throttledEnhancedVideoAccessRouteHighlightRequestHandler);
    }

    onKeyDown = (event) => {
        // Don't intercept Ctrl/Cmd key combos (e.g. Ctrl+F for search)
        if (event.ctrlKey || event.metaKey) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        switch (event.key) {
            case 'Escape': // likely handled by the browser already, if native fullscreen supported
                if (this.mapboxControlShouldFullscreen) {
                    this.mapboxToggleFullscreenControlCallback(!this.mapboxControlShouldFullscreen);
                }
                break;
            case 'f':
                //if (!this.mapboxVehiclePopupIsEditingMessage) {
                    if (!this.mapboxControlShouldFullscreen) {
                        this.mapboxToggleFullscreenControlCallback(!this.mapboxControlShouldFullscreen);
                    }
                //}
                break;
            default:
                break;
        }
    }

    componentDidMount() {
        const { mapId, theme, mapCenter } = this.props;
        var { mapZoom } = this.props;
        var { lon, lat } = mapCenter;

        if (!lat && !lon) {  // lat and lon can be null
            // default to show north america (RAV-426) (same default values as components/mapbox/mapboxMapDashboard ~ln147):
            mapZoom = 4; // "country" zoom level
            lon = -99.954143;
            lat = 41.9735726;
        }

        const mapContainer = document.getElementById(this.props.mapId);
        if (mapContainer) {
            mapContainer.addEventListener("keydown", this.onKeyDown, false);
        }
        fscreen.addEventListener('fullscreenchange', this.onFullscreenChange, false);

        this.map = MapboxHelper.createMap({
            container: mapId,
            theme: theme,
            center: [lon, lat],
            zoom: mapZoom,
            onLoad: () => {
                if(this.props.card) {
                    this.setCard(this.props.card);
                }
                this.mapLoaded = true;
                this.mapboxAddToggleSatelliteControl();
                this.mapboxAddToggleGeofenceControl();
                this.mapboxAddToggleFullscreenControl();
            }
        });
    }

    componentDidUpdate(prevProps) {

        var cardSet = false;

        if(!this.mapLoaded) return;

        /* Handle changing props.  Here's some use cases, behaviour seen, and how to handle it:
            - Changing card:  mapCenter changes ( but all the same values), card object changes (including content within line card id) and selectedEvent cycles to null and back.  Load new card and zoom to fit 
            - Select new Event:  selectedEvent changes, but does not cycle through null.  zoom to newly selected Event 
            - New event appears in current card: card object changes (but same card id), mapCenter changes (but all the same values), selectedEvent cycles to null and back.  Don't do anything


        So, the behaviour is as follows:
            - Ignore mapCenter changes
            - Ignore if selectedEvent is null as either old or new
            - if selectedEvent old and new is non-null zoom to new event
            - If cardId changes in card object zoom to fit, otherwise do nothing

        */

        // this.handlePropChange(prevProps, 'mapCenter', center => {/* this.map.flyTo({center})*/});
        if(prevProps.card && this.props.card)
        {
            if(prevProps.card.cardId !== this.props.card.cardId)
            {
                cardSet = true; 
                this.setCard(this.props.card);
            }
            else
            {
                this.setCard(this.props.card, false);
            }
        }
        // this.handlePropChange(prevProps, 'card', card => { cardSet = true; this.setCard(card); });
        this.handlePropChange(prevProps, 'selectedEvent', evt => 
            { 
                if(!evt)
                    return;

                if(!cardSet)
                {
                    cardSet = true;
                    this.setCard(this.props.card); 
                }
                if(evt.geoStamp) 
                {
                    this.map.flyTo({center: [evt.geoStamp.lon, evt.geoStamp.lat]});
                }
            }
        );

    }

    handlePropChange = (prevProps, propName, action) => {
        // If either old or new is null, don't do anything
        if (prevProps[propName] === undefined) return; // console.warn(`property '${propName}' is previously undefined`)
        if (this.props[propName] === undefined) return; // console.warn(`property '${propName}' is presently undefined`)
        if (prevProps[propName] === null) return; // console.warn(`property '${propName}' is previously undefined`)
        if (this.props[propName] === null) return; // console.warn(`property '${propName}' is presently undefined`)
        if (prevProps[propName] !== this.props[propName]) {
            // console.log(`props.${propName} changed`, JSON.parse(JSON.stringify(prevProps[propName])), JSON.parse(JSON.stringify(this.props[propName])));
            action(this.props[propName]);
        }
    }

    componentWillUnmount() {

        document.removeEventListener(Events.ENHANCED_VIDEO_ACCESS_ROUTE_HIGHLIGHT_REQUEST, this.throttledEnhancedVideoAccessRouteHighlightRequestHandler);

        const mapContainer = document.getElementById(this.props.mapId);
        if (mapContainer) {
            mapContainer.removeEventListener("keydown", this.onKeyDown, false);
        }
        fscreen.removeEventListener('fullscreenchange', this.onFullscreenChange, false);
        if (this.mapboxControlShouldFullscreen) {
            this.props.setLayoutFullscreen(false); 
            fscreen.exitFullscreen();
        }

        if (this.map) {
            this.map.remove();
        }
    }

    setCard(card, zoomToExtents = true) {

        if (!card) return;
        const route = card.route;
        const start = route && route.length ? route[0] : card.start;
        const end = route && route.length ? route[route.length - 1] : card.end;
        this.setEndpoints(start, end, card.route, card.type, zoomToExtents);
        this.setRoute(card.route, card.type, zoomToExtents);
        this.setEvents(card.events, card.type, this.props.selectedEvent);
        this.setGeofences(card.geofences);
    }

    throttleFunction = (func, delay) => {

        if (this.sourceEnhancedVideoAccessRouteUpdateTimerId) {
            return;
        }
    
        this.sourceEnhancedVideoAccessRouteUpdateTimerId = setTimeout( () => {
            func()
            this.sourceEnhancedVideoAccessRouteUpdateTimerId = undefined;
        }, delay)
    }

    throttledEnhancedVideoAccessRouteHighlightRequestHandler = (event) => {
        this.throttleFunction(() => {
            this.enhancedVideoAccessRouteHighlight(event)
        }, ENHANCED_VIDEO_ACCESS_ROUTE_HIGHLIGHT_THROTTLE_DELAY);
    }
    
    enhancedVideoAccessRouteHighlight = (event) => {//(ravenUuid, startIndex = 0, endIndex = 0) => {

        if (!event.detail) {
            console.warn("mapboxMapDashboard enhancedVideoAccessRouteHighlight event.detail not found.");
            return;
        }
        const ravenUuid = event.detail.ravenUuid;
        const startIndex = event.detail.startIndex;
        const endIndex = event.detail.endIndex;

        if (!ravenUuid) {
            console.warn("mapboxMapDashboard enhancedVideoAccessRouteHighlight event.detail not found.");
            return;
        }

        if (!this.sourceEnhancedVideoAccessRouteFeatureCollection) {
            console.error("mapboxMapDashboard enhancedVideoAccessRouteHighlight sourceEnhancedVideoAccessRouteFeatureCollection not ready");
            return;
        }

        if (!this.sourceEnhancedVideoAccessPointFeatureCollection) {
            console.error("mapboxMapDashboard enhancedVideoAccessRouteHighlight sourceEnhancedVideoAccessPointFeatureCollection not ready");
            return;
        }
        const sourceEnhancedVideoAccessRoute = this.sourceEnhancedVideoAccessRouteFeatureCollection;
        const sourceEnhancedVideoAccessPoint = this.sourceEnhancedVideoAccessPointFeatureCollection;

        if (!this.sourceEnhancedVideoAccessRoute) { 
            this.sourceEnhancedVideoAccessRoute = this.map.getSource(SOURCE_ENHANCED_VIDEO_ACCESS_ROUTE_NAME);
            if (!this.sourceEnhancedVideoAccessRoute) {
                console.warn("mapboxMapDashboard enhancedVideoAccessRouteHighlight SOURCE_ENHANCED_VIDEO_ACCESS_ROUTE_NAME source not ready");
                return;
            }
        }

        if (!this.sourceEnhancedVideoAccessPoint) { 
            this.sourceEnhancedVideoAccessPoint = this.map.getSource(SOURCE_ENHANCED_VIDEO_ACCESS_POINT_NAME);
            if (!this.sourceEnhancedVideoAccessPoint) {
                console.warn("mapboxMapDashboard enhancedVideoAccessRouteHighlight SOURCE_ENHANCED_VIDEO_ACCESS_POINT_NAME source not ready");
                return;
            }
        }

        if (startIndex === undefined && endIndex == undefined) {
            this.sourceEnhancedVideoAccessPoint.setData({
                type: sourceEnhancedVideoAccessPoint.type,
                features: [{
                    properties: {
                        ravenUuid: sourceEnhancedVideoAccessPoint.features[0].properties.ravenUuid,
                        status: sourceEnhancedVideoAccessPoint.features[0].properties.status,
                        lineCategory: sourceEnhancedVideoAccessPoint.features[0].properties.lineCategory,
                        timestamps: []
                    },
                    geometry: {
                        type: "Point",
                        coordinates: []
                    },
                    id: sourceEnhancedVideoAccessPoint.id
                }]
            });

            this.sourceEnhancedVideoAccessRoute.setData({
                type: sourceEnhancedVideoAccessRoute.type,
                features: [{
                    properties: {
                        ravenUuid: sourceEnhancedVideoAccessRoute.features[0].properties.ravenUuid,
                        status: sourceEnhancedVideoAccessRoute.features[0].properties.status,
                        lineCategory: sourceEnhancedVideoAccessRoute.features[0].properties.lineCategory,
                        timestamps: []
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: []
                    },
                    id: sourceEnhancedVideoAccessRoute.id
                }]
            });

            return;
        }

        if (startIndex !== endIndex) {

            if (!sourceEnhancedVideoAccessRoute ||
                !sourceEnhancedVideoAccessRoute.features ||
                !sourceEnhancedVideoAccessRoute.features[0].properties ||
                !sourceEnhancedVideoAccessRoute.features[0].geometry) {
                console.error("mapboxMapDashboard enhancedVideoAccessRouteHighlight sourceEnhancedVideoAccessRoute not found");
                return;
            }

            this.sourceEnhancedVideoAccessPoint.setData({
                type: sourceEnhancedVideoAccessPoint.type,
                features: [{
                    properties: {
                        ravenUuid: sourceEnhancedVideoAccessPoint.features[0].properties.ravenUuid,
                        status: sourceEnhancedVideoAccessPoint.features[0].properties.status,
                        lineCategory: sourceEnhancedVideoAccessPoint.features[0].properties.lineCategory,
                        timestamps: []
                    },
                    geometry: {
                        type: "Point",
                        coordinates: []
                    },
                    id: sourceEnhancedVideoAccessPoint.id
                }]
            });

            this.sourceEnhancedVideoAccessRoute.setData({
                type: sourceEnhancedVideoAccessRoute.type,
                features: [{
                    properties: {
                        ravenUuid: sourceEnhancedVideoAccessRoute.features[0].properties.ravenUuid,
                        status: sourceEnhancedVideoAccessRoute.features[0].properties.status,
                        lineCategory: sourceEnhancedVideoAccessRoute.features[0].properties.lineCategory,
                        timestamps: sourceEnhancedVideoAccessRoute.features[0].properties.timestamps.slice(startIndex, endIndex)
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: sourceEnhancedVideoAccessRoute.features[0].geometry.coordinates.slice(startIndex, endIndex)
                    },
                    id: sourceEnhancedVideoAccessRoute.id
                }]
            });

        } else {

            if (!sourceEnhancedVideoAccessPoint ||
                !sourceEnhancedVideoAccessPoint.features ||
                !sourceEnhancedVideoAccessPoint.features[0].properties ||
                !sourceEnhancedVideoAccessPoint.features[0].geometry) {
                console.error("mapboxMapDashboard enhancedVideoAccessRouteHighlight sourceEnhancedVideoAccessPoint not found");
                return;
            }

            this.sourceEnhancedVideoAccessRoute.setData({
                type: sourceEnhancedVideoAccessRoute.type,
                features: [{
                    properties: {
                        ravenUuid: sourceEnhancedVideoAccessRoute.features[0].properties.ravenUuid,
                        status: sourceEnhancedVideoAccessRoute.features[0].properties.status,
                        lineCategory: sourceEnhancedVideoAccessRoute.features[0].properties.lineCategory,
                        timestamps: []
                    },
                    geometry: {
                        type: "LineString",
                        coordinates: []
                    },
                    id: sourceEnhancedVideoAccessRoute.id
                }]
            });

            this.sourceEnhancedVideoAccessPoint.setData({
                type: sourceEnhancedVideoAccessPoint.type,
                features: [{
                    properties: {
                        ravenUuid: sourceEnhancedVideoAccessPoint.features[0].properties.ravenUuid,
                        status: sourceEnhancedVideoAccessPoint.features[0].properties.status,
                        lineCategory: sourceEnhancedVideoAccessPoint.features[0].properties.lineCategory,
                        timestamps: sourceEnhancedVideoAccessPoint.features[0].properties.timestamps[startIndex]
                    },
                    geometry: {
                        type: "Point",
                        coordinates: sourceEnhancedVideoAccessPoint.features[0].geometry.coordinates[endIndex]
                    },
                    id: sourceEnhancedVideoAccessPoint.id
                }]
            });
        }
    }

    setRoute(route, cardType, zoomToExtents) {
        var hasroute = false;

        // if the card is loading or the route is invalid for drawing a line or
        // it's a parked card, we won't render a route, but need to make sure we
        // clear the data source to invalidate any previously drawn route
        if(route)
        {
            hasroute = true;
        }
        if(!route || route.length === 1 || cardType === 'PARKED') route = [];

        const coordinates = route.map(geoStamp => [geoStamp.lon, geoStamp.lat]);
        const timestamps = route.map(geoStamp => geoStamp.ts);
        const data = {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    geometry: {
                        type: 'LineString',
                        coordinates},
                    properties: {
                        type: 'route',
                        timestamps: timestamps,
                        canViewVideoStream: this.props.canViewVideoStream
                    }
                }
            ]
        };

        // ENHANCED VIDEO ACCESS HIGHLIGHT ROUTE
        this.sourceEnhancedVideoAccessRouteFeatureCollection = data; // TODO - fine tune this method for tracking a off-map optimized source for map content
        this.sourceEnhancedVideoAccessPointFeatureCollection = {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates},
                    properties: {
                        type: 'route',
                        timestamps: timestamps
                    }
                }
            ]
        };
        const highlightSource = this.map.getSource(SOURCE_ENHANCED_VIDEO_ACCESS_ROUTE_NAME);
        if (!highlightSource) { // just add the source for now (highlight request sets the data)
            this.map.addSource(SOURCE_ENHANCED_VIDEO_ACCESS_ROUTE_NAME, {
                type: 'geojson',
                data: { // add empty source data
                    'type': 'FeatureCollection',
                    'features': []
                }
            });

            this.map.addLayer({
                id: LAYER_ENHANCED_VIDEO_ACCESS_ROUTE_NAME,
                type: 'line',
                source: SOURCE_ENHANCED_VIDEO_ACCESS_ROUTE_NAME,
                layout: {
                    'line-join': 'round', //"bevel", "round", "miter" (default)
                    'line-cap': 'round' //"butt" (default), "round", "square"
                },
                paint: {
                    "line-color": "#B2D8FF",
                    "line-opacity": 0.8,
                    'line-width': 24,
                }
            }, ENDPOINTS_LAYER_ID);

            this.map.addSource(SOURCE_ENHANCED_VIDEO_ACCESS_POINT_NAME, {
                type: 'geojson',
                data: { // add empty source data
                    'type': 'FeatureCollection',
                    'features': []
                }
            });

            this.map.addLayer({
                id: LAYER_ENHANCED_VIDEO_ACCESS_POINT_NAME,
                type: 'circle',
                source: SOURCE_ENHANCED_VIDEO_ACCESS_POINT_NAME,
                paint: {
                    'circle-radius': 12,
                    "circle-color": "#B2D8FF",
                    'circle-opacity': 0.8
                }
            }, LAYER_ENHANCED_VIDEO_ACCESS_ROUTE_NAME);
        }

        const source = this.map.getSource(ROUTE_SOURCE_ID);
        if (source) {
            // console.log('overwriting route source');
            source.setData(data);
        } else {
            // console.log('adding route source');
            this.map.addSource(ROUTE_SOURCE_ID, {
                type:'geojson',
                data
            });
            // console.log('adding route layer');
            this.map.addLayer({
                id: ROUTE_LAYER_ID,
                type: 'line',
                source: ROUTE_SOURCE_ID,
                layout: {
                    'line-join': 'round',
                    'line-cap': 'round'
                },
                paint: {
                    'line-color': ROUTE_LINE_COLOR,
                    'line-width': ROUTE_LINE_WIDTH,
                }
            }, LAYER_ENHANCED_VIDEO_ACCESS_POINT_NAME);
        }

        this.map.on('mousemove', GEOFENCE_LAYER_ID, this.mouseInGeofence);
        this.map.on('mouseleave', GEOFENCE_LAYER_ID, this.mouseExitGeofence);

        if (this.historyPopup) {
            this.historyPopup.removeFromMap(this.map, ROUTE_LAYER_ID);
        }
        this.historyPopup = new HistoryPopup(this.checkCardVideoAvailability(), (ts) => this.props.onLiveStream('CAMERA_ROAD', ts) );

        this.historyPopup.addToMap(this.map, ROUTE_LAYER_ID, ROUTE_SOURCE_ID);

        if (zoomToExtents || this.routeDelayedZoom) {
            this.zoomToRoute(route);

            this.routeDelayedZoom = !hasroute;
        }

    }

    createFeatureForEvent(event, index, selected)
    {
        const propertiesForEvent = (event) => {
            let category = 'DEFAULT';

            if (RAVENS_EVENTS_ENGINE.includes(event.type))    category = 'ENGINE_STATE_CHANGE';
            else if (RAVENS_EVENTS_SPEEDING.includes(event.type)) category = 'SPEEDING';
            else if (RAVENS_EVENTS_GEOFENCE.includes(event.type)) category = 'GEOFENCE';
            else if (RAVEN_EVENTS_AI.includes(event.type))       category = 'AI';
            else if (RAVEN_EVENTS_PROBLEM.includes(event.type))  category = 'PROBLEM';

            const colorKey = selected ? `${category}_SELECTED` : category;

            return {
                icon: EventIcons.DEFAULT,
                color: EventColors[colorKey] // EventColors['AI_SELECTED'] is the same as saying EventColors.AI_SELECTED
            };
        };

        return {
            type: 'Feature',
            geometry: {
                type: 'Point',
                coordinates: [event.geoStamp.lon, event.geoStamp.lat]
            },
            properties: {
                type: 'event',
                ...propertiesForEvent(event, index)
            }
        };
    }

    setEvents(events, cardType, selectedEvent) {
        // if the card is loading or it's a parked card, we want to clear
        // the data source for the events layer
        if(!events) events = [];
        else if (cardType === 'PARKED') events = [];

        // remove bad events
        events = events.filter(event => event.geoStamp || console.warn('setEvents removed event with no geoStamp', event));
        // TODO: this copy/sort step can be removed when historyPage is able to
        // sort events chronologically instead of reverse-chronologically
        events = [...events]; // make a copy for re-sorting
        events.sort((e1, e2) => e1.date - e2.date); // sort events earliest first

        // drop the first and last engine state changes
        const isEngineStateChenge = event => ['EVENT_ENGINE_ON', 'EVENT_ENGINE_OFF'].includes(event.type);
        const firstEvent = events.shift();
        if (firstEvent && !isEngineStateChenge(firstEvent)) {
            console.warn('setEvents tried to shift the first event but found an unexpected event type. putting it back.', firstEvent);
            events.unshift(firstEvent);
        }
        const lastEvent = events.pop();
        if (lastEvent && !isEngineStateChenge(lastEvent)) {
            console.warn('setEvents tried to pop the last event but found an unexpected event type. putting it back.', lastEvent);
            events.push(lastEvent);
        }

        const features = events.map((event, index) => this.createFeatureForEvent(event, index, false));

        const data = {
                type: 'FeatureCollection',
                features
            };

        const source = this.map.getSource(EVENTS_SOURCE_ID);
        if (source) {
            // console.log('overwriting events source');
            source.setData(data);
        } else {
            // console.log('adding events source');
            this.map.addSource(EVENTS_SOURCE_ID, {
                type:'geojson',
                data
            });
            // console.log('adding events layer');
            this.map.addLayer({
                'id': EVENTS_LAYER_ID,
                'type': 'symbol',
                'source': EVENTS_SOURCE_ID,
                'layout': {
                    'icon-size': 0.4,
                    'icon-offset': [0, -30],
                    'icon-allow-overlap': true,
                    'icon-image': {
                        'type': 'identity',
                        'property': 'icon'
                    },
                },
                'paint': {
                    'icon-color': {
                        'type': 'identity',
                        'property': 'color'
                    },
                },
            });
        }

        // Selected Event (don't do anything with parked cards)

        if(cardType !== 'PARKED' && selectedEvent && selectedEvent.eventId && selectedEvent.geoStamp)
        {
            var selectedFeature = this.createFeatureForEvent(selectedEvent, 0, true);

            const sdata = {
                    type: 'FeatureCollection',
                    features: [selectedFeature]
                };

            const ssource = this.map.getSource(SELECTED_EVENTS_SOURCE_ID);
            if (ssource) {
                // console.log('overwriting events source');
                ssource.setData(sdata);
            } else {
                // console.log('adding events source');
                this.map.addSource(SELECTED_EVENTS_SOURCE_ID, {
                    type:'geojson',
                    data: sdata
                });
                // console.log('adding events layer');
                this.map.addLayer({
                    'id': SELECTED_EVENTS_LAYER_ID,
                    'type': 'symbol',
                    'source': SELECTED_EVENTS_SOURCE_ID,
                    'layout': {
                        'icon-size': 0.4,
                        'icon-offset': [0, -30],
                        'icon-allow-overlap': true,
                        'icon-image': {
                            'type': 'identity',
                            'property': 'icon'
                        },
                    },
                    'paint': {
                        'icon-color': {
                            'type': 'identity',
                            'property': 'color'
                        },
                    },
                });
            }
        }
        else
        {
            const ssource = this.map.getSource(SELECTED_EVENTS_SOURCE_ID);
            if (ssource) {
                const sdata = {
                    type: 'FeatureCollection',
                    features: []
                };
                ssource.setData(sdata);
            }
        }


    }

    setGeofences(geofences) {
        // if the card is loading or it's a parked card, we want to clear
        // the data source for the events layer
        if(!geofences) geofences = [];

        // TODO: This is basically a dup of the dashboard map code

        var features = [];
        var labels = [];

        // Find all the geofences that are mentioned in events 

        var neededGeofences = new Set();

        if (this.props.card.events) {
            this.props.card.events.forEach((elem) => {
                if(elem.eventParams && elem.eventParams['EVENT_PARAM_GEOFENCE_ID'])
                {
                    neededGeofences.add(elem.eventParams['EVENT_PARAM_GEOFENCE_ID']);
                }
            });
        }

        var endTime = this.props.card.end ? moment(this.props.card.end.ts) : moment();

        geofences.forEach((geofence, index) => {

            // See if this geofence should be shown or not
            // The list is already culled from the Kloud, so it only contains one that exist during this card
            // Keep the ones that have a corresponding event
            // Keep the ones that have null end time (haven't been invalidated yet)
            // Remove ones that don't exist at the end of the trip

            if(!neededGeofences.has(geofence.geofenceId) && geofence.end && endTime.isBefore(geofence.end))
            {
                return;
            }

            // FIXME - ARG!  Why can't this be the same as the code from redux?

            const darkThemeSelected = this.props.theme !== 'light' ? true : false;

            var color = geofence.style ? geofence.style['fill-color'] : '#000000';

            const geojson = geofence.geojson;

            if(geojson.geometry.type === "Point"){
                features.push( MapboxHelper2.createGeoJSONCircle(
                        geofence.geojson.geometry.coordinates,
                        geofence.geojson.properties.radius/1000,
                        {
                            "id": geofence.geofenceId,
                            "place_name": geofence.name,
                            "fill-color": color,
                            "outline-color": color,
                            "selected": "0"
                        })
                );
            }

            if(geojson.geometry.type === "Polygon"){
                features.push( MapboxHelper2.createGeoJSONPolygon(
                    geojson.geometry.coordinates,
                    {
                        "id": geofence.geofenceId,
                        "place_name": geofence.name,
                        "fill-color": color,
                        "outline-color": color,
                        "selected": "0"
                    })
                );
            }

            const labelCoordinates = geojson.geometry.type === "Polygon" ? MapboxHelper2.getCenterOfPolygon(geojson.geometry.coordinates) : geojson.geometry.coordinates;

            labels.push( {
                "type": "Feature",
                "properties": {
                    "id": geofence.geofenceId,
                    "place_name": geofence.name,
                    "text-color": (darkThemeSelected || ColorUtil.isReallyDark(color)) ? "#ffffff" : "#000",
                },
                "geometry": {
                    "type": "Point",
                    "coordinates": labelCoordinates
                },
                id: geofence.geofenceId,
            });


        });

        const data = {
                type: 'FeatureCollection',
                features
            };

        const labelData = {
                type: 'FeatureCollection',
                features: labels
            };

        const source = this.map.getSource(GEOFENCE_SOURCE_ID);
        const labelSource = this.map.getSource(GEOFENCE_LABEL_SOURCE_ID);
        if (source) {
            source.setData(data);
            labelSource.setData(labelData);
        } else {
            this.map.addSource(GEOFENCE_SOURCE_ID, {
                type:'geojson',
                data
            });
            this.map.addLayer({
                'id': GEOFENCE_LAYER_ID,
                'type': 'fill',
                'source': GEOFENCE_SOURCE_ID,
                "paint": {
                    "fill-opacity": ["case",
                        ["boolean", ["feature-state", "isHidden"], false],
                        // hidden
                        0,
                        // otherwise
                        0.5,
                    ],
                    "fill-color": ["case",
                        ["boolean", ["feature-state", "isHidden"], false],
                        // hidden
                        ['literal', '#555555'],
                        // fallback
                        ['coalesce', ['get', 'fill-color'], '#555555'],
                    ],
                    "fill-outline-color": ["case",
                        ["boolean", ["feature-state", "isHidden"], false],
                        // hidden
                        // ['rgba', 0,0,0,0],
                        ['literal', '#555555'],
                        // fallback
                        ['coalesce', ['get', 'fill-color'], '#555555'],
                    ],
                }

            });

            this.map.addSource(GEOFENCE_LABEL_SOURCE_ID, {
                type:'geojson',
                data: labelData
            });

            this.map.addLayer({
                "id": GEOFENCE_LABEL_LAYER_ID, // Selected layer required since you cannot use an expression at the layout properties level. "feature-state data expressions are not supported with layout properties"
                "type": "symbol",
                "source": GEOFENCE_LABEL_SOURCE_ID,
                "paint": {
                    "text-opacity": ["step",
                        ["zoom"],
                            ["case",
                                ["boolean", ["feature-state", "visible"], false],
                                1,
                                0,
                            ],
                        15, // zoom level 15, always see it
                            1,
                    ],
                    // "text-opacity": 1.0,

                    "text-color": ["get", "text-color"],
                },
                "layout": {
                    "text-field": ["get", "place_name"],
                    "text-justify": "center",
                    "text-allow-overlap": true,
                    "icon-allow-overlap": true,
                }
            });
        }

    }

    setEndpoints(start, end, route, cardType, zoomToExtents) {
        const endpoints = [];
        const addEndpoint = (geostamp, icon) => {
            if(geostamp && geostamp.lon && geostamp.lat) {
                endpoints.push({ ...geostamp, icon });
                return true;
            }
            return false;
        };
        if(cardType === 'PARKED') {
            // we'll only one, prefer start
            if(!addEndpoint(start, EventIcons.PARKED)) addEndpoint(end, EventIcons.PARKED);
        } else {
            addEndpoint(start, EventIcons.TRIP_START);
            addEndpoint(end, EventIcons.TRIP_END);
        }

        const features = endpoints.map(endpoint => ({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [endpoint.lon, endpoint.lat]
                },
                properties: {
                    type: 'trip-endpoint',
                    icon: endpoint.icon
                }
        }));

        const data = {
                type: 'FeatureCollection',
                features
            };

        const source = this.map.getSource(ENDPOINTS_SOURCE_ID);
        if (source) {
            // console.log('overwriting endpoints source');
            source.setData(data);
        } else {
            // console.log('adding endpoints source');
            this.map.addSource(ENDPOINTS_SOURCE_ID, {
                type:'geojson',
                data
            });
            // console.log('adding endpoints layer');
            this.map.addLayer({
                'id': ENDPOINTS_LAYER_ID,
                'type': 'symbol',
                'source': ENDPOINTS_SOURCE_ID,
                'layout': {
                    'icon-allow-overlap': true,
                    'icon-image': {
                        'type': 'identity',
                        'property': 'icon'
                    },
                },
            });
        }
        // zoom extents if no route yet or a parked card
        if((zoomToExtents || this.endPointsDelayedZoom) && 
                    (cardType === 'PARKED' || (!route || route.length < 2))) {
            this.zoomToRoute(endpoints);
            this.endPointsDelayedZoom = (endpoints.length === 0);
        }
    }

    checkCardVideoAvailability = () => { // TODO in lieu of more detailed information, this is a really basic PoC-grade check

        if (!this.props.historicalStreamingEnabled) { // feature if FALSE
            return false;
        }
        if (this.props.ravenOffline) {
            return false;
        }
        if (!this.props.card) {
            console.warn("History CardMapPanel checkCardVideoAvailability card without any events");
            return false;
        }
        if (!this.props.card.events || this.props.card.events.length === 0) {
            console.warn("History CardMapPanel checkCardVideoAvailability card without any events");
            return false;
        }

        for (let i = 0; i < this.props.card.events.length; i++) { // using basic for loop so we can break (in this case return true)
            const event = this.props.card.events[i];
            if (!event.videoAvailable) continue;
            if (event.videoAvailable.road) return true;
            if (event.videoAvailable.cabin) return true;
        }
        return false;
    }


    mouseInGeofence = (e) => {

        // ARG dup'd from MapboxHelperDashboard
        var i;

        var newids = [];
        var newidsLookup = {};

        for(i = 0; i < e.features.length; i++)
        {
            var newid = e.features[i].id;

            const curFeatureState = this.map.getFeatureState({ source: GEOFENCE_SOURCE_ID, id: newid });
            if(curFeatureState.isHidden)
            {
                continue;
            }

            newids.push(newid);

            newidsLookup[newid] = true;

            this.map.setFeatureState({source: GEOFENCE_LABEL_SOURCE_ID, id: newid}, { visible: true});
        }

        if(this.currentHoverGeofenceIds)
        {
            for(i = 0; i < this.currentHoverGeofenceIds.length; i++)
            {
                var id = this.currentHoverGeofenceIds[i];
                if(newidsLookup[id])
                {
                    // old and new match, do nothing
                    continue;
                }

                // Old one doesn't exist any more, hide.
                this.map.setFeatureState({source: GEOFENCE_LABEL_SOURCE_ID, id: id}, { visible: false});
        
            }
        }

        this.currentHoverGeofenceIds = newids;

    }

    mouseExitGeofence = () => {

        if(!this.currentHoverGeofenceIds)
            return;

        var i;

        for(i = 0; i < this.currentHoverGeofenceIds.length; i++)
        {
            var id = this.currentHoverGeofenceIds[i];
            this.map.setFeatureState({source: GEOFENCE_LABEL_SOURCE_ID, id: id}, { visible: false});
        }

        this.currentHoverGeofenceIds = [];

    }

    resize = () => {
        if (this.map) this.map.resize();
    }

    ////////////////
    //MAP CONTROLS//
    ////////////////

    animateCameraToPoint(point, speed = 1000) {
        try {
            this.map.panTo(point, {
                duration: speed,
                easing: (t) => { return t } //linear easing
            });
        } catch (e) {
            console.error(e);
        }
    }

    fitCardRouteOnMap = () => {
        this.zoomToRoute(this.props.card);
    }

    zoomToRoute(route) {
        if(route && route[0]) {
            const bounds = new mapboxgl.LngLatBounds();
            route.filter((geoStamp, i) =>
                (i === 0 || i === route.length - 1 || i % 10 === 0)
            ).forEach(geoStamp => bounds.extend([geoStamp.lon, geoStamp.lat]));
            // console.log('zoomToRoute', JSON.stringify(bounds));
            this.zoomToExtents(bounds);
        }
    }

    zoomToExtents(bounds) {
        this.map.fitBounds(bounds, {
            padding: 50,
            speed: 1.7,
            maxZoom: this.props.mapZoom,
        });
    }

    mapboxToggleGeofenceControlCallback = (shouldDisplayGeofence) => {

        var scopedThis = this;
        this.props.card.geofences.forEach( geofence => {
            scopedThis.map.setFeatureState({source: GEOFENCE_SOURCE_ID, id: geofence.geofenceId}, { isHidden: !shouldDisplayGeofence});
        });
    }

    mapboxToggleSatelliteControlCallback = (mapboxControlShouldDisplaySatellite) => {
        this.mapboxControlShouldDisplaySatelliteByDefault = mapboxControlShouldDisplaySatellite;
        this.mapLoaded = false;
        if (this.mapboxControlShouldDisplaySatelliteByDefault === true) {
            this.map.setStyle('mapbox://styles/dan-in-ottawa/' + MAPBOX_SATELLITE_STYLE_ID);
        } else {
            this.map.setStyle(this.props.theme !== 'light' ? 'mapbox://styles/dan-in-ottawa/' + MAPBOX_DEFAULT_DARK_STYLE_ID : 'mapbox://styles/dan-in-ottawa/' + MAPBOX_DEFAULT_LIGHT_STYLE_ID);
        }

        const scopedThis = this;
        clearTimeout(this.mapboxStyleChangedCompletedCheckInterval);
        this.mapboxStyleChangedCompletedCheckInterval = setInterval(function() {

            if (scopedThis.mapLoaded === true) {
                clearTimeout(scopedThis.mapboxStyleChangedCompletedCheckInterval);
                return;
            }

            const styleChangeCompleted = scopedThis.map.isStyleLoaded();
            if (styleChangeCompleted === true) {

                const imageNameArray = scopedThis.map.listImages();
                for (var i = 0; i < imageNameArray.length; i++) {
                    if (imageNameArray[i] === EventIcons.TRIP_START) {
                        console.warn("start-marker image appears to still be present from previous style.  Skipping attempt");
                        return;
                    }
                    if (imageNameArray[i] === EventIcons.TRIP_END) {
                        console.warn("end-marker image appears to still be present from previous style.  Skipping attempt");
                        return;
                    }
                    if (imageNameArray[i] === EventIcons.PARKED) {
                        console.warn("parked-marker image appears to still be present from previous style.  Skipping attempt");
                        return;
                    }
                }

                scopedThis.mapLoaded = true;

                clearTimeout(scopedThis.mapboxStyleChangedCompletedCheckInterval);

                // replace the image assets added at runtime
                MapboxHelper.initMapImages(scopedThis.map)
                    .catch(error => console.error('error in initMapImages', error))
                    .then(() => {
                        // replace the data sources and layers added at runtime
                        scopedThis.setCard(scopedThis.props.card, false);
                    });
            }
        }, 100);
    }

    mapboxAddToggleSatelliteControl () {
        // console.log("this.mapboxControlShouldDisplaySatelliteByDefault: ", this.mapboxControlShouldDisplaySatelliteByDefault);
        this.mapboxToggleSatelliteControl = new MapboxToggleSatelliteControl(
            this.mapboxControlShouldDisplaySatelliteByDefault,
            this.mapboxToggleSatelliteControlCallback
        );
        this.map.addControl(this.mapboxToggleSatelliteControl);
    }

    mapboxAddToggleGeofenceControl () {
        // console.log("this.mapboxControlShouldDisplaySatelliteByDefault: ", this.mapboxControlShouldDisplaySatelliteByDefault);
        this.mapboxToggleGeofenceControl = new MapboxToggleGeofenceControl(
            true,
            this.mapboxToggleGeofenceControlCallback
        );
        this.map.addControl(this.mapboxToggleGeofenceControl);
    }

    mapboxAddToggleFullscreenControl () {
        this.mapboxToggleFullscreenControl = new MapboxToggleFullscreenControl(
            this.props.mapboxControlShouldFullscreen,
            this.mapboxToggleFullscreenControlCallback
        );
        this.map.addControl(this.mapboxToggleFullscreenControl);
    }

    mapboxToggleFullscreenControlCallback = (shouldFullscreen) => {

        this.mapboxControlShouldFullscreen = shouldFullscreen;
        this.mapboxToggleFullscreenControl.mapboxControlShouldFullscreen = this.mapboxControlShouldFullscreen; // this is redundant when mapboxToggleFullscreenControl calls mapboxToggleFullscreenControlCallback

        const documentElement = document.documentElement; // Get the documentElement (<html>) to display the page in fullscreen (https://www.w3schools.com/howto/howto_js_fullscreen.asp)

        if ((fscreen.fullscreenEnabled === false) || // 'fullscreenEnabled' means native browser fullscreen is supported/enabled (doesn't mean it's actively fullscreened)
            !documentElement) { // assuming an undefined documentElement is bad enough that we should skip a native fullscreen attempt
            this.props.setLayoutFullscreen(this.mapboxControlShouldFullscreen);
            return;
        }

        if (this.mapboxControlShouldFullscreen) {
            if (fscreen.fullscreenElement === null) { // checking fullscreen mode is not already active
                fscreen.requestFullscreen(documentElement);
            }
        } else {
            if (fscreen.fullscreenElement !== null) { // checking fullscreen mode is still active
                fscreen.exitFullscreen();
            }
        }
    }

    onFullscreenChange = (event) => { // https://developer.mozilla.org/en-US/docs/Web/API/Document/fullscreenchange_event
        
        if (fscreen.fullscreenElement !== null) {
            this.mapboxControlShouldFullscreen = true;
        } else {
            this.mapboxControlShouldFullscreen = false;
        }
        this.mapboxToggleFullscreenControl.mapboxControlShouldFullscreen = this.mapboxControlShouldFullscreen;
        this.props.setLayoutFullscreen(this.mapboxControlShouldFullscreen);                            
    }

    render() {
        return (
            <div className='mapbox-container'>
                <ResizeThrottler interval={300} callback={this.resize} />
                <div id={this.props.mapId} className='mapbox-map mapboxgl-ctrl'></div>
            </div>
        );
    }
}
